module.exports = __webpack_public_path__ + "static/media/Seam_4540.607a927e.jpg";